import * as React from "react";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

export interface Props {
  overline?: string | JSX.Element;
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  align?: "left" | "center";
  darkMode?: boolean;
  noGutterBottom?: boolean;
  isMainHeadline?: boolean;
}

export const PageHeader = (props: React.PropsWithChildren<Props>) => {
  const {
    overline,
    title,
    subtitle,
    align,
    darkMode,
    noGutterBottom,
    isMainHeadline,
  } = props;

  return (
    <Box
      mb={noGutterBottom === true ? 0 : 4}
      color={darkMode === true ? "white" : undefined}
    >
      {overline && (
        <Typography
          variant="h6"
          gutterBottom={true}
          color={darkMode === true ? "inherit" : "textSecondary"}
          align={align ?? "center"}
          style={{ textTransform: "uppercase", fontWeight: 500 }}
        >
          {overline}
        </Typography>
      )}
      {title && (
        <Typography
          variant="h4"
          color={darkMode === true ? "inherit" : "textPrimary"}
          align={align ?? "center"}
          gutterBottom={true}
          variantMapping={isMainHeadline ? { h4: "h1" } : undefined}
        >
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography
          variant="h6"
          align={align ?? "center"}
          color={darkMode === true ? "inherit" : "textSecondary"}
          data-aos="fade-up"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/PageHeader.tsx